import React from 'react';
import { useNavigate } from 'react-router';

import ROUTES from '@constants/routes';

const useRedirectForbidden = () => {
  const navigate = useNavigate();

  return React.useCallback(() => {
    navigate(ROUTES.FORBIDDEN);
  }, [navigate]);
};

export default useRedirectForbidden;
